import React from 'react';

import { useAppDispatch, useAppSelector } from '~redux/hooks';
import combinedActions from '~redux/combinedActions';

import Modal from '~components/atoms/Modal';
import RoleDetailsForm from '../RolesRoleDetailsForm';

import { TRoleListing } from '~types/feat/admin';

const RolesDeleteRoleModal = () => {
    const dispatch = useAppDispatch();

    const isOpen = useAppSelector(state => state.admin.modals.deleteRoleModalIsOpen);
    const isLoading = useAppSelector(state => state.admin.loadings.deleteRole);
    const error = useAppSelector(state => state.admin.errors.deleteRole);
    const roleDetails = useAppSelector(state => state.admin.roleDetails);

    const handleModalOnClose = () => {
        dispatch(combinedActions.adminResetDeleteRoleState());
        dispatch(combinedActions.adminSetDeleteRoleModalIsOpen(false));
    };

    const handleOnSubmit = (data: TRoleListing) => {
        if (!isLoading) {
            const {
                roleId,
                roleName,
                status,
                access,
                allBranchAccess,
            } = data;

            dispatch(combinedActions.adminDeleteRoleAttempt({
                roleId,
                roleName,
                status,
                access,
                allBranchAccess,
            }));
        }
    };

    return (
        <Modal
            title='Delete Role'
            isOpen={isOpen}
            onClose={handleModalOnClose}
        >
            <RoleDetailsForm
                submitButtonLabel='Delete Role'
                onSubmit={handleOnSubmit}
                actionButtonIsLoading={isLoading}
                error={error}
                inputIsDisabled={true}
                initialRoleDetails={roleDetails}
            />
        </Modal>
    );
};

export default RolesDeleteRoleModal;
